export default {
      id: "linkedin-usage",
      viewBox: "0 0 17.4 17.4",
      url: __webpack_public_path__ + "svg/sprite.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }